import { logger as N } from "../../shared-lib/index.js";
import FeatureFlag from "./feature-flag.js";
export function newFeatureFlagFromJson(e) {
  if (e[FeatureFlag.ui.os] && "boolean" == typeof e[FeatureFlag.ui.Fe])
    return new FeatureFlag(
      e[FeatureFlag.ui.os],
      e[FeatureFlag.ui.Fe],
      e[FeatureFlag.ui.we],
      e[FeatureFlag.ui.xe],
    );
  N.info(`Unable to create feature flag from ${JSON.stringify(e, null, 2)}`);
}
export function newFeatureFlagFromSerializedValue(e) {
  if (e[FeatureFlag.hs.os] && "boolean" == typeof e[FeatureFlag.hs.Fe])
    return new FeatureFlag(
      e[FeatureFlag.hs.os],
      e[FeatureFlag.hs.Fe],
      e[FeatureFlag.hs.we],
      e[FeatureFlag.hs.xe],
    );
  N.info(
    `Unable to deserialize feature flag from ${JSON.stringify(e, null, 2)}`,
  );
}
